export const TITLES = {
  PRODUCTS: 'Our At-Home Health Tests - Results You Can Understand',
};

export const DESCRIPTIONS = {
  PRODUCTS: `Everlywell makes at-home health testing easier than ever. Order
    directly, test from the comfort of home, get easy-to-read results within
    just days.`,
};
